export default __webpack_public_path__ + "static/backgroundNewsletter-ff9e4714ae65f0b06e1c67a7583b476a.png";